// src/pages/GuidePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const GuidePage = () => {
  return (
    <>
      <style>{`
        .gb { font-family: 'Hiragino Sans','Yu Gothic','Noto Sans JP',sans-serif; background:#f8fafc; color:#1f2937; line-height:1.7; font-size:15px; min-height:100vh; }
        .gh { background:linear-gradient(135deg,#1e1b4b 0%,#312e81 50%,#1e40af 100%); color:#fff; padding:48px 24px 40px; text-align:center; }
        .gh-logo { display:inline-flex; align-items:center; gap:10px; background:rgba(255,255,255,0.15); border-radius:50px; padding:8px 20px; margin-bottom:20px; font-size:13px; font-weight:700; }
        .gh h1 { font-size:clamp(24px,6vw,36px); font-weight:900; margin-bottom:12px; line-height:1.3; }
        .gh p { font-size:14px; color:rgba(255,255,255,0.8); max-width:500px; margin:0 auto; }
        .gc { max-width:680px; margin:0 auto; padding:0 16px 60px; }
        .gs { margin-top:32px; }
        .gs-label { display:inline-flex; align-items:center; gap:6px; font-size:11px; font-weight:700; letter-spacing:0.1em; color:#4f46e5; background:#ede9fe; padding:4px 12px; border-radius:20px; margin-bottom:14px; }
        .gs-title { font-size:20px; font-weight:900; color:#1f2937; margin-bottom:16px; line-height:1.4; }
        .gtip { border-radius:12px; padding:14px 16px; margin-bottom:12px; font-size:13px; line-height:1.6; border-left:4px solid; }
        .gtip.w { background:#fffbeb; border-color:#f59e0b; color:#78350f; }
        .gtip.i { background:#eff6ff; border-color:#3b82f6; color:#1e3a8a; }
        .gtip.s { background:#f0fdf4; border-color:#22c55e; color:#14532d; }
        .gurl { background:#1f2937; color:#a5f3fc; border-radius:10px; padding:12px 16px; font-family:monospace; font-size:13px; word-break:break-all; margin:12px 0; display:flex; align-items:center; gap:10px; }
        .gurl span { color:#6ee7b7; font-size:11px; white-space:nowrap; }
        .gss { background:#f9fafb; border:1px solid #e5e7eb; border-radius:12px; padding:14px 16px; margin-bottom:10px; display:flex; gap:12px; align-items:flex-start; }
        .gsi { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .gst h4 { font-size:13px; font-weight:700; margin-bottom:3px; }
        .gst p { font-size:12px; color:#4b5563; line-height:1.5; margin:0; }
        .gfg { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
        @media(max-width:480px){ .gfg{grid-template-columns:1fr;} }
        .gfc { background:#fff; border:1px solid #e5e7eb; border-radius:14px; padding:16px; }
        .gfi { width:40px; height:40px; border-radius:10px; display:flex; align-items:center; justify-content:center; margin-bottom:10px; }
        .gfn { font-size:13px; font-weight:700; margin-bottom:4px; }
        .gfd { font-size:12px; color:#4b5563; line-height:1.5; }
        .gfb { display:inline-block; font-size:10px; font-weight:700; padding:2px 8px; border-radius:20px; margin-top:6px; }
        .gsl { display:flex; flex-direction:column; gap:16px; }
        .gstep { display:flex; gap:14px; align-items:flex-start; }
        .gsn { width:32px; height:32px; border-radius:50%; background:linear-gradient(135deg,#4f46e5,#7c3aed); color:#fff; font-size:14px; font-weight:900; display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:2px; }
        .gsc h4 { font-size:15px; font-weight:700; margin-bottom:4px; }
        .gsc p { font-size:13px; color:#4b5563; line-height:1.6; margin:0; }
        .gdiv { height:1px; background:#e5e7eb; margin:28px 0; }
        .gcta { display:block; width:100%; padding:16px; background:linear-gradient(135deg,#4f46e5,#7c3aed); color:#fff; font-size:15px; font-weight:900; text-align:center; border-radius:14px; text-decoration:none; margin:20px 0; box-shadow:0 4px 16px rgba(99,102,241,0.35); }
        .gfoot { text-align:center; padding:32px 24px; font-size:12px; color:#4b5563; border-top:1px solid #e5e7eb; margin-top:40px; }
        * { box-sizing:border-box; }
      `}</style>

      <div className="gb">
        <div className="gh">
          <div className="gh-logo">⚡ NOBISHIROコンピテンシー®</div>
          <h1>ベータテスター<br/>使い方ガイド</h1>
          <p>このガイドに沿って設定・使用するとより快適にご利用いただけます</p>
        </div>

        <div className="gc">

          <div className="gs">
            <div className="gs-label">はじめに</div>
            <div className="gs-title">まずこちらからアクセス</div>
            <div className="gtip w">
              <strong>⚠️ スマートフォンをお使いの方へ</strong><br/>
              iPhoneの場合は必ず <strong>Safari</strong> でアクセスしてください。<br/>
              LINEやInstagramなどのアプリ内ブラウザではGoogleログインが正常に動作しません。
            </div>
            <div className="gurl">
              🌐 www.nobishiro-competency.com
              <span>← Safariで開く</span>
            </div>
            <div className="gtip i">
              <strong>💡 招待コードについて</strong><br/>
              招待URLからアクセスした場合、コードは自動で適用されます。<br/>
              登録完了後、自動的に <strong>Businessプラン</strong> が付与されます。
            </div>
          </div>

          <div className="gdiv"/>

          <div className="gs">
            <div className="gs-label">📱 スマホ設定</div>
            <div className="gs-title">ホーム画面に追加して<br/>アプリのように使う</div>
            <div className="gtip s">
              ホーム画面に追加するとアプリのように一発で起動できます。毎日の学習記録に便利です。
            </div>
            <div style={{fontSize:13,fontWeight:700,color:'#1d4ed8',marginBottom:10}}>
              📱 iPhone（Safari）の場合
            </div>
            {[
              {bg:'#dbeafe', title:'① Safariでサイトを開く', desc:'www.nobishiro-competency.com をSafariのアドレスバーに入力してアクセスします'},
              {bg:'#f0fdf4', title:'② 画面下の「共有」ボタンをタップ', desc:'Safariの画面下部中央にある □↑ のアイコン（共有ボタン）をタップします'},
              {bg:'#fef9c3', title:'③「ホーム画面に追加」を選択', desc:'メニューをスクロールして「ホーム画面に追加」をタップします'},
              {bg:'#ede9fe', title:'④「追加」をタップして完了', desc:'名前はそのままで「追加」をタップ。ホーム画面にNOBISHIROのアイコンが表示されます'},
            ].map((s,i) => (
              <div key={i} className="gss">
                <div className="gsi" style={{background:s.bg}}>✓</div>
                <div className="gst"><h4>{s.title}</h4><p>{s.desc}</p></div>
              </div>
            ))}
            <div style={{background:'#f9fafb',border:'1px solid #e5e7eb',borderRadius:12,padding:'14px 16px',fontSize:13,color:'#4b5563'}}>
              <strong style={{color:'#1f2937'}}>📱 Androidの場合</strong><br/>
              Chromeを開き、右上の「⋮」メニュー →「ホーム画面に追加」を選択してください。
            </div>
          </div>

          <div className="gdiv"/>

          <div className="gs">
            <div className="gs-label">⚡ 機能ガイド</div>
            <div className="gs-title">各機能の役割</div>
            <div className="gfg">
              {[
                {name:'📊 サマリー', desc:'学習時間の累計・今週の実績・成長曲線をまとめて確認できるホーム画面', badge:'毎日確認', bb:'#dbeafe', bc:'#1e40af', ib:'#dbeafe'},
                {name:'🎤 学習ログ記録', desc:'今日の学習時間・カテゴリ・内容を記録。音声入力にも対応しています', badge:'毎日記録', bb:'#fef9c3', bc:'#92400e', ib:'#fef9c3'},
                {name:'📈 成長パターン', desc:'あなたの成長タイプ・停滞（プラトー）の状態を診断。突破口を提示します', badge:'週1回', bb:'#d1fae5', bc:'#065f46', ib:'#d1fae5'},
                {name:'🧠 認知特性', desc:'あなたの思考スタイル・処理方法・注意パターンを可視化。最適な学習法がわかります', badge:'1回診断', bb:'#ede9fe', bc:'#5b21b6', ib:'#ede9fe'},
                {name:'🔥 突破プラン', desc:'成長の壁を7ステップで突破。0.5x〜2xのペースから自分に合ったリズムを選べます', badge:'おすすめ', bb:'#ffedd5', bc:'#9a3412', ib:'#ffedd5'},
                {name:'⚡ TRIZ問題分析', desc:'仕事や学習の課題を入力すると、40の人材発達法則から最適な突破口を提案します', badge:'課題がある時', bb:'#fce7f3', bc:'#9d174d', ib:'#fce7f3'},
                {name:'👥 チーム管理', desc:'4人1組のフォーマンセルでチームを作り、メンバーの成長を一緒に管理できます', badge:'Business限定', bb:'#dbeafe', bc:'#1e40af', ib:'#dbeafe'},
                {name:'🏆 達成フィード', desc:'仲間の突破プラン達成をリアルタイムで確認。いいねで応援し合えます', badge:'LIVE', bb:'#f0fdf4', bc:'#065f46', ib:'#f0fdf4'},
              ].map((f,i) => (
                <div key={i} className="gfc">
                  <div className="gfi" style={{background:f.ib}}>⚡</div>
                  <div className="gfn">{f.name}</div>
                  <div className="gfd">{f.desc}</div>
                  <span className="gfb" style={{background:f.bb,color:f.bc}}>{f.badge}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="gdiv"/>

          <div className="gs">
            <div className="gs-label">⭐ 活用法</div>
            <div className="gs-title">おすすめの使い方</div>
            <div className="gsl">
              {[
                {title:'まず診断を受ける（初回のみ・10分）', desc:'「成長パターン」「認知特性」タブで診断を受けると、あなたに最適な学習法と突破口がわかります。'},
                {title:'毎日学習後にログを記録（30秒）', desc:'サマリー画面の「学習ログを記録する」から時間・カテゴリ・内容を記録します。音声入力が便利です。'},
                {title:'突破プランを始める（7ステップ）', desc:'あなたのタイプに合わせた7ステップを、自分のペースで進めます。達成すると仲間のフィードに表示されます。'},
                {title:'課題があればTRIZ問題分析を活用', desc:'仕事・学習で行き詰まったら、TRIZ問題分析に課題を入力してみてください。科学的な突破口が見つかります。'},
              ].map((s,i) => (
                <div key={i} className="gstep">
                  <div className="gsn">{i+1}</div>
                  <div className="gsc"><h4>{s.title}</h4><p>{s.desc}</p></div>
                </div>
              ))}
            </div>
          </div>

          <div className="gdiv"/>

          <div className="gs">
            <div className="gtip i">
              <strong>📬 フィードバックをお聞かせください</strong><br/>
              使いづらい点・バグ・改善要望など、どんな些細なことでも富永勇貴まで直接お送りください。<br/><br/>
              <strong>tominagacccyuki@gmail.com</strong><br/>
              またはLINEにてご連絡ください。
            </div>
            <Link to="/dashboard" className="gcta">ダッシュボードへ →</Link>
          </div>

        </div>

        <div className="gfoot">
          <div style={{marginBottom:8,fontWeight:700,color:'#1f2937'}}>NOBISHIROコンピテンシー®</div>
          富永コーチングカントリークラブ株式会社 / 運営責任者：富永 勇貴<br/>
          <Link to="/terms" style={{color:'#4f46e5',textDecoration:'none'}}>利用規約</Link>　
          <Link to="/privacy" style={{color:'#4f46e5',textDecoration:'none'}}>プライバシーポリシー</Link>　
          <Link to="/tokusho" style={{color:'#4f46e5',textDecoration:'none'}}>特定商取引法</Link>
        </div>
      </div>
    </>
  );
};

export default GuidePage;
